import { Text, View } from "tamagui";
import { EventCard } from "../../../components/design-system/EventCard";
import { RefreshControl, SectionList } from "react-native";
import { customColorTokens } from "../../../../tamagui.config";
import { currentUserAtom } from "../../../../atoms/global";
import { useAtomValue } from "jotai";
import { Event } from "../../../types/event";
import { groupEventsByDate } from "../../../utils/groupEventsByDate";
import { useApiQuery } from "../../../../lib/api";
import { useCallback, useState } from "react";

export const MySchedule = ({
  ListHeaderComponent,
}: {
  ListHeaderComponent?: React.ReactElement;
}) => {
  const user = useAtomValue(currentUserAtom);

  const [refreshing, setRefreshing] = useState(false);
  const { data, refetch } = useApiQuery<{ events: Event[] }>(
    ["events-attending"],
    "/api/v1/events/attending",
    { enabled: !!user?.id }
  );

  const events = data?.events ?? null;
  const onRefresh = useCallback(async () => {
    setRefreshing(true);
    await refetch();
    setRefreshing(false);
  }, [refetch]);

  const sections = groupEventsByDate(events);

  const renderSectionHeader = ({
    section: { title },
  }: {
    section: {
      title: string;
    };
  }) => (
    <View bg="$brandParchment" p="$4">
      <Text fontSize={16} fontFamily="$heading" textTransform="uppercase">
        {title}
      </Text>
    </View>
  );

  const renderItem = ({ item }: { item: Event }) => {
    return (
      <View px="$4" mb="$4">
        <EventCard event={item} />
      </View>
    );
  };

  return (
    <SectionList
      ListHeaderComponent={ListHeaderComponent}
      sections={sections}
      keyExtractor={(item) => item.id ?? ""}
      renderItem={renderItem}
      renderSectionHeader={renderSectionHeader}
      style={{ backgroundColor: customColorTokens.brandParchment, flex: 1 }}
      refreshControl={
        <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
      }
      ListEmptyComponent={
        <View
          flex={1}
          justifyContent="center"
          alignItems="center"
          h="100%"
          minHeight={300}
          gap="$4"
        >
          <Text fontSize={20}>{`Looks like your schedule is clear!`}</Text>
        </View>
      }
      contentContainerStyle={{
        paddingBottom: 100,
      }}
    />
  );
};
